import * as R from 'ramda'

export const RECIPIENTS = 'recipients'
export const SEND_OPTIONS = 'sendOptions'
export const BEACON_SCHEDULE = 'beaconSchedule'
export const IS_SCHEDULE = 'isSchedule'
export const NOTI_TYPE = 'notiType'
export const OVERRIDE_TRANSLATION = 'overrideTranslation'
export const DESCRIPTION = 'description'
export const MEDIA = 'media'
export const EVENT = 'event'
export const VOUCHER = 'voucher'
export const ALLOW_CONVERSATION = 'allowConversation'
export const getOverrideTranslation = R.prop(OVERRIDE_TRANSLATION)
export const setOverrideTranslation = R.compose(
  R.set,
  R.lensProp(OVERRIDE_TRANSLATION),
)
